const GRIEGHALLEN_IMG = "/images/grieghallen.webp";

const FACTS = [
  { k: "Main hall", v: "1,500 seats" },
  { k: "Opened", v: "1978 — home of the Bergen Philharmonic" },
  { k: "Location", v: "City centre, 10 min from the harbour" },
  { k: "Format", v: "One main stage + parallel rooms" },
];

export default function TheVenue() {
  return (
    <section
      id="venue"
      data-testid="grieghallen-section"
      className="section section-dark bg-[var(--dark)] text-[var(--bg)]"
    >
      <div className="max-w-page container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-index">06</span>
              <span className="eyebrow eyebrow--accent" data-testid="grieghallen-eyebrow">
                The venue
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-[-0.02em]">
              Grieghallen.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex md:items-end">
            <p className="text-[14px] md:text-[15px] leading-[1.55] text-white/60 max-w-[38ch]">
              Bergen's concert house and the city's most iconic stage —
              built for full days of listening.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start">
          <div className="md:col-span-7">
            <div className="aspect-[4/3] md:aspect-[16/10] w-full overflow-hidden bg-[var(--dark-2)]">
              <img
                src={GRIEGHALLEN_IMG}
                alt="Grieghallen at dusk — the glass facade glowing before an event"
                loading="lazy"
                className="w-full h-full object-cover img-editorial"
                data-testid="grieghallen-image"
              />
            </div>
            <p className="text-[12px] text-white/45 mt-3">
              Grieghallen, Bergen — evening before doors open.
            </p>
          </div>

          <div className="md:col-span-5 md:pt-2">
            <p className="text-[16px] md:text-[17px] leading-[1.5] text-white/80 max-w-[46ch]">
              One main hall for the plenary programme, generous foyers for the
              conversations between — and the acoustics of a world-class
              concert house.
            </p>
            <dl className="mt-10 border-t border-white/20">
              {FACTS.map((f) => (
                <div
                  key={f.k}
                  className="grid grid-cols-12 gap-4 py-4 border-b border-white/12"
                  data-testid={`grieghallen-fact-${f.k.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <dt className="col-span-5 text-[11px] uppercase tracking-[0.18em] text-white/45 pt-1">
                    {f.k}
                  </dt>
                  <dd className="col-span-7 text-[15px] text-white/90">{f.v}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
